export const VIEW_LOG = 1;
export const VIEW_USERSEARCH = 2;

export const VIEW_REPORT_DAY = 11;
export const VIEW_REPORT_SALES = 12;
export const VIEW_REPORT_HIME = 13;
export const VIEW_REPORT_MEDIA = 14;
export const VIEW_REPORT_SB = 15;
export const VIEW_REPORT_STAFF = 16;

// Setting

export const SETTING_OWNER = 1;
export const SETTING_OFFICE = 2;
export const SETTING_SHOP = 3;

export const SETTING_HIME_CREATE = 11;
export const SETTING_HIME_UPDATE = 12;
export const SETTING_DRIVER_CREATE = 13;
export const SETTING_DRIVER_UPDATE = 14;
export const SETTING_SCOUT_REPLACE = 17;

// Data

export const USER_CREATE = 1;
export const USER_DELETE = 2;
export const USER_MERGE = 3;
export const USER_UPDATE_ADDONLY = 4;
export const USER_UPDATE_OTHERS = 5;
export const USER_UPDATE_UO_ADDONLY = 6;
export const USER_UPDATE_UO_OTHERS = 7;
export const USER_UPDATE_POINT = 8;

export const RESV_CREATE = 21;
export const RESV_DELETE_BY_CREATOR = 22;
export const RESV_DELETE_BY_OTHERS = 23;
export const RESV_UPDATE_STATEONLY = 24;
export const RESV_UPDATE_BY_CREATOR = 25;
export const RESV_UPDATE_BY_OTHERS = 26;
export const RESV_UPDATE_DATE = 27;
export const RESV_UPDATE_STATUS = 28;
export const RESV_MONEYTEMP = 31;
export const RESV_RECV = 32;
export const RESV_RECVCANCEL_BY_INPUT = 33;
export const RESV_RECVCANCEL_BY_OTHERS = 34;

export const CALL_UPDATE_OTHERS = 40;
export const CALL_CREATE = 41;
export const CALL_UPDATE_USER = 42;
export const CALL_UPDATE_TAKE = 43;

// Schedule

export const OFFICE_FIX_HIME = 1;
export const OFFICE_FIXCANCEL_HIME = 2;
export const OFFICE_FIXDAY_CREATE = 3;
export const OFFICE_FIXDAY_CANCEL = 4;
export const OFFICE_FIXDAY_REPLACEDATA = 5;

export const HIMEDAY_UPDATE_WORK = 11;
export const HIMEDAY_UPDATE_DATA = 12;
export const HIMEDAY_UPDATE_STATE = 13;

export const SCHDULEMEMO_REPLACE = 21;
export const SCHDULEDRIVER_REPLACE = 22;

export const REPORT_UPDATE_EXPENSE = 31;    
export const MONEY_REPLACE = 41;